import React from "react";
import {StyleSheet, Text, View, StatusBar,  I18nManager,Image, ScrollView, Animated, TouchableOpacity} from 'react-native';

import { NavigationContainer } from '@react-navigation/native';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { useFonts } from 'expo-font';

const Stack = createNativeStackNavigator();
import * as Updates from 'expo-updates';

import Register from "./Pages/Register";


import Splash from "./Pages/Splash";
import Welcome from "./Pages/Welcome";
import Home from "./Pages/Home";
import Friends from "./Pages/Friends";
import Withdraw from "./Pages/Withdraw";
import Deposit from "./Pages/Deposit";
import Login from "./Pages/Login";
import Start from "./Pages/Start";
import Invation from "./Pages/Invation";


import Password from "./Pages/Password";
import Edit from "./Pages/Edit";
import Web from "./Pages/Web";
import Update from "./Pages/Update";



export default function App() {

    const [fontsLoaded] = useFonts({
        'novaria': require('./assets/fonts/novaria.ttf'),
    });

    //rtl force
    if( I18nManager.isRTL){

        I18nManager.forceRTL(false);
        I18nManager.allowRTL(false);

        Updates.reloadAsync().then();
    }



    return (
        <>
            {fontsLoaded ?
                <NavigationContainer   presentation="transparentModal">
                    <Stack.Navigator  screenOptions={{
                        headerShown : false
                    }}>


                        <Stack.Screen name="Splash" component={Splash} />
                        <Stack.Screen name="Welcome" component={Welcome} />
                        <Stack.Screen name="Start" component={Start} />
                        <Stack.Screen name="Home" component={Home} />
                        <Stack.Screen name="Friends" component={Friends} />
                        <Stack.Screen name="Withdraw" component={Withdraw} />
                        <Stack.Screen name="Deposit" component={Deposit} />
                        <Stack.Screen name="Login" component={Login} />
                        <Stack.Screen name="Invation" component={Invation} />
                        <Stack.Screen name="Password" component={Password} />
                        <Stack.Screen name="Edit" component={Edit} />
                        <Stack.Screen name="Web" component={Web} />
                        <Stack.Screen name="Update" component={Update} />
                        <Stack.Screen name="Register" component={Register} />

                    </Stack.Navigator>
                    <StatusBar
                        backgroundColor={'#19222f'}
                        barStyle={'white-content'}
                        style="auto"
                    />
                </NavigationContainer>
                :
                <View style={{flex:1,justifyContent:'center',alignItems:'center',backgroundColor:'#9E2225'}}>
                    <Text style={{fontSize:20 , color:'#FFF'}}>
                                    Loading ...
                    </Text>
                </View>
            }
        </>
  );
}

